import styled, { css } from "styled-components";
import { Wrapper } from "AppReact";

const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    flex-direction: column;
    height: ${displayState?.height ?? ''};
    justify-content: space-between;
  `}
`;

export default Wrapper(template)
